import { Tooltip } from '@mui/material'
import { useAllTechnologyQuery } from '../../helpers/technologyApi'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { serviceNames } from '../../constant'
import Loader from '../Loader/Loader'

const TechData = () => {

    const [slug, setslug] = useState()

    const { data, isFetching } = useAllTechnologyQuery(slug)

    const location = useLocation()

    useEffect(() => {

        let x = location.pathname
        x = x.split('/')[1]

        let isSlugExist = serviceNames.filter(item => item === x)

        if (isSlugExist.length) {
            setslug(isSlugExist[0])
        }

    }, [location])

    return (

        <div>
            {isFetching ? <Loader text='Loading...' height={'50vh'} /> : (
                <div>
                    {data.technology.length > 0 && (
                        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-4 md:px-12'>
                            <div>
                                <h1
                                    className='text-xl md:text-2xl font-bold text-center dark:text-white'
                                >
                                    Our Favorite Folder Of The
                                </h1>
                                <h1
                                    className='text-xl md:text-2xl font-bold text-center text-red-500'
                                >
                                    Technologies We Use
                                </h1>

                            </div>

                            <div className='flex justify-center items-center flex-wrap gap-4 md:gap-9 my-7'>
                                {data.technology.map((item, i) => (
                                    <Tooltip title={item.title} arrow placement='top-end' >
                                        <div key={i}
                                            onClick={() => window.scrollTo(0, 0)}
                                            className='h-[70px] cursor-pointer group relative md:h-[90px] w-[70px] md:w-[90px] hover:scale-90 bg-slate-100 duration-700 flex justify-center items-center p-3 md:p-4 rounded-full'>
                                            <img src={item.img} alt='img' className='object-contain ' />
                                            <span className="group-hover:ping-once absolute rounded-full bg-slate-500 -z-20 duration-1000 opacity-75"></span>

                                        </div>

                                    </Tooltip>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default TechData